<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <div v-if="branch_validate">
                    <span class="error">The Branch field is required.</span>
                  </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'dailyVisit'">
          <form @submit.prevent="validateDailyVisit('dailyVisit')" data-vv-scope="dailyVisit">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="name_visitor" v-model="addData.name" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.name_visitor') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Email</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="email" v-model="addData.email" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.email') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Phone Number</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="phone_number" v-validate="'required|numeric'" v-model="addData.phone_number" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.phone_number') }}</span>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Amount</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input :value="totalPayment" class="border-bottom" name="amount" v-validate="'required|numeric'" v-model="addData.amount" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.amount') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="addData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{item.branch.codename}}</template><template v-else>XX</template>-{{item.id}}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Visit Type</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select class="border-bottom" name="visit_type" v-validate="'required'" v-model="addData.daily_visit_type">
                      <option v-for="item in optionsDailyVisitType" :key="item.value" :value="item.value">{{ item.text }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('dailyVisit.visit_type') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Remark</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="remark" v-model="addData.remark" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.remark') }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="mb-10">
              <div>Payment Methods</div>
              <hr class="short-line left mb-20">
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 1</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1" v-model="addData.payment_type_id_1" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                        <span class="error">{{ errors.first('dailyVisit.payment_type_id_1') }}</span>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1" :disabled="[1,6, 9].includes(addData.payment_type_id_1)" name="paymentCard1" v-model="addData.payment_card_id_1">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                        <div v-if="![1,9].includes(addData.payment_type_id_1) && addData.payment_type_id_1 != null && addData.payment_card_id_1 == null">
                          <span class="error">The payment_card_id_1 field is required.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount" v-model="amountPaymentCard1" v-bind="money2"></money>
                  <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                    <span class="error">The payment first amount field is required.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 2</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select name="payment_type_id_2" @change="changePaymentType2" v-model="addData.payment_type_id_2" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2" :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6" name="paymentCard2" v-model="addData.payment_card_id_2">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                </div>
              </div>
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" v-model="addData.notes"></textarea>
                </b-col>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn-primary">Submit</button>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { ModelSelect } from 'vue-search-select'
import { Auth } from '@/api'

export default {
  name: 'addDailyVisit',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      fullNameDetail: '',
      linkDataPrivy: '',
      errorMoney: 'The amount field is required!',
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'dailyVisit',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      detailMember: {},
      detailCS: {},
      CSName: '',
      modalShow: false,
      linkPrivyId: 'https://sandbox.privy.id/user',
      branch_validate: false,
      addData: {
        branch_id: null,
        member_id: null,
        customer_service_id: null,
        amount: '',
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_amount_1: '',
        payment_type_id_2: null,
        payment_card_id_2: null,
        payment_amount_2: '',
        notes: '',
        remark: '',
        daily_visit_type: null
      },
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
        { value: 'extendPt', text: 'Extend PT' },
        { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' },
        { value: 'merchandise', text: 'Merchandise' },
        { value: 'starterPack', text: 'Starter Pack' }
      ],
      optionsDailyVisitType: [
        { value: null, text: 'Please select' },
        { value: 'Daily Visit', text: 'Daily Visit' },
        { value: 'Package', text: 'Package' },
        { value: 'Event', text: 'Event' },
        { value: 'Others', text: 'Others' },
      ],
      optionsMember: [
        { value: null, text: 'Please select' }
      ]
    }
  },
  methods: {
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else if (event === 'grabAndGoGopay') {
        this.$router.push('/allForm/addgrabAndGoGopay')
      } else if (event === 'corporateOutstanding') {
        this.$router.push('/allForm/addCorporateOutstanding')
      } else if (event === 'extendPt') {
        this.$router.push('/allForm/addExtendPt')
      } else if (event === 'merchandise') {
        this.$router.push('/allForm/addMerchandise')
      } else if (event === 'starterPack') {
        this.$router.push('/allForm/addStarterPack')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    async changePaymentCard1 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },
    changePaymentType1 (event) {
      if (event === 1) {
        this.addData.payment_card_id_1 = null
      } else if (event === 6) {
        this.addData.payment_card_id_1 = 1
      } else {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2 (event) {
      if (event === 1) {
        this.addData.payment_card_id_2 = null
      } else if (event === 6) {
        this.addData.payment_card_id_2 = 1
      } else {
        this.addData.payment_card_id_2 = null
      }
    },
    getMemberData (event) {
      axios.get('fitness/v1/member/' + event).then(response => {
        this.detailMember = response.data.data
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect (event) {
      return event
    },
    changeValueMoney (event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validateDailyVisit (data6) {
      this.$validator.validateAll(data6).then((result) => {
        if (![1,9].includes(this.addData.payment_type_id_1) && this.addData.payment_card_id_1 == null) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if (this.addData.branch_id == null) {
          this.branch_validate = true
          this.$toast.success('The Branch field is required!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if(result) {
          this.addData.payment_amount_1 = this.amountPaymentCard1
          this.addData.payment_amount_2 = this.amountPaymentCard2
          axios.post('crm/v1/form_daily_visit/', this.addData).then(response => {
            // console.log('test', response)
            this.$router.push('/allForm')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      this.branch_validate = false
      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      // this.addData.customer_service_id = Auth.Session.get().paradigm_id
      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
        this.itemsPaymentCard = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
        this.itemsPaymentType = response.data.data.rows
        this.itemsPaymentType2 = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service/').then(response => {
        this.dataCS = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  computed: {
    getMemberId: function() {
      return this.addData.member_id
    },
    totalPayment: function() {
      let calculatedTotal = this.addData.amount
      this.amountPaymentCard1 = this.addData.amount
      return calculatedTotal
    },
    paymentLeft: function() {
      if (String(this.amountPaymentCard1).length > String(this.addData.amount).length) {
        this.amountPaymentCard2 = 0
      } else {
        this.amountPaymentCard2 = this.addData.amount - this.amountPaymentCard1
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
      }
    }
  },
  watch: {
    getMemberId () {
      axios.get('fitness/v1/member/' + this.addData.member_id).then(response => {
        this.detailMember = response.data.data
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
        // this.addDataPrivy.branch_id = response.data.data.branch_id
        // this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()

    const roleId = Auth.Session.get().paradigm_role
    if (roleId == 6 || roleId == '6') {
      this.addData.branch_id = Auth.Session.get().paradigm_branch_id
      this.addData.customer_service_id = Auth.Session.get().paradigm_id

      this.getCSData(this.addData.customer_service_id)
    }
  }
}
</script>

<style>
</style>
